import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=b4b07a9a&scoped=true&"
import script from "./PasswordRequirements.vue?vue&type=script&lang=js&"
export * from "./PasswordRequirements.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRequirements.vue?vue&type=style&index=0&id=b4b07a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b07a9a",
  null
  
)

export default component.exports